import React, { useState, useEffect } from "react";

import EntryItem from "./EntryItem";
import { donorEntryQuery } from "./queries";
import useSweepstakesQuery from "../../lib/useSweepstakesQuery";
import PaginationControl, { PAGE_SIZE_OPTIONS } from "./PaginationControl";

const EntryList = ({ authToken, setAuthToken, setMode, setGreeting }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);
  
  const { data, error, loading } = useSweepstakesQuery(donorEntryQuery, {
    variables: { page, pageSize },
    context: {
      headers: {
        authorization: authToken,
      },
    },
  });

  const donorGuestEntries = data?.donorGuestEntries;

  useEffect(() => {
    if (error) {
      setAuthToken(null);
      setMode("email");
    }
  }, [error, setAuthToken, setMode]);

  useEffect(() => {
    if (donorGuestEntries && donorGuestEntries.items.length > 0) {
      setGreeting(donorGuestEntries.items[0].email);
    }
  }, [donorGuestEntries, setGreeting]);

  if (loading || error) {
    return null;
  }

  return (
    <React.Fragment>
      <PaginationControl donorGuestEntries={donorGuestEntries} setPage={setPage} setPageSize={setPageSize} page={page} pageSize={pageSize} />
      {donorGuestEntries.items.map((entry) => (
        <EntryItem key={entry.id} item={entry} />
      ))}
    </React.Fragment>
  )
}

export default EntryList;
